export default {"src":"/_next/static/media/CctpLogoColor.79c70e47.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};